export const normalizeDeliveryPartner = (partner) => {
  if (!partner) return "";
  const normalized = String(partner).replace(/\s+/g, "").toLowerCase();

  if (normalized.includes("uber")) return "Uber";
  if (normalized.includes("grub") || normalized === "gh") return "GrubHub";

  return partner;
};

export const getLatestDeliveryEventType = (order) =>
  order?.currentDeliveryStatus?.events?.[0]?.type ||
  order?.deliveryWebhookStatus?.events?.[0]?.type ||
  "";

export const getDeliveryStatusText = (order) => {
  if (typeof order?.currentDeliveryStatus === "string") {
    return order.currentDeliveryStatus;
  }

  return getLatestDeliveryEventType(order);
};

export const isDeliveryCancelled = (order) => {
  const statusText = String(getDeliveryStatusText(order) || "").toLowerCase();
  return statusText.includes("cancel");
};

export const isDeliveryRefunded = (order) => {
  const statusText = String(getDeliveryStatusText(order) || "").toLowerCase();
  return statusText.includes("refund");
};

export const isDeliveryRestricted = (order) => {
  const latestEventType = String(getLatestDeliveryEventType(order) || "").toUpperCase();
  return ["UNASSIGNED", "CANCELED", "CANCELLED"].includes(latestEventType) || isDeliveryCancelled(order);
};

export const getFirstDefinedValue = (...values) =>
  values.find((value) => value !== undefined && value !== null && value !== "");

export const getMinutesFromEtaValue = (value) => {
  if (value === undefined || value === null || value === "") return null;

  if (typeof value === "number") {
    return Math.round(value);
  }

  if (typeof value === "string") {
    const numericValue = Number(value.trim().replace(/[^0-9.-]/g, ""));
    if (!Number.isNaN(numericValue)) return Math.round(numericValue);
  }

  return null;
};

export const getEtaMinutes = (order) =>
  getMinutesFromEtaValue(getFirstDefinedValue(
    order?.etaMinutes,
    order?.deliveryEtaMinutes,
    order?.dropoffEtaMinutes,
    order?.estimatedDeliveryMinutes,
    order?.uberEta,
    order?.grubHubEta,
  ));

export const getPickupMinutes = (order) =>
  getMinutesFromEtaValue(getFirstDefinedValue(
    order?.pickupMinutes,
    order?.pickupEtaMinutes,
    order?.estimatedPickupMinutes
  ));

export const getTrackingUrl = (order) =>
  order?.tracking_url ||
  order?.trackingUrl ||
  order?.uberTrackingUrl ||
  order?.uber_tracking_url ||
  order?.deliveryTrackingUrl ||
  order?.delivery_tracking_url;
